import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { addDatapointConfig } from 'owa-analytics-actions';
import type { CalendarEntry } from 'owa-graph-schema';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { action } from 'satcheljs';

function setCalendarColorFunc(
    colorScheme: ColorScheme,
    hexColorString: null,
    calendar: CalendarEntry
);
function setCalendarColorFunc(colorScheme: null, hexColorString: string, calendar: CalendarEntry);
function setCalendarColorFunc(
    colorScheme: ColorScheme,
    hexColorString: string,
    calendar: CalendarEntry
) {
    return {
        colorScheme,
        hexColorString,
        calendar,
    };
}

/**
 * The action sets the calendar color.
 */
export const setCalendarColor = action('setCalendarColor', setCalendarColorFunc);

/**
 * The action sets the charm icon for the calendar.
 */
export const setCalendarCharm = action(
    'setCalendarCharm',
    (iconId: number, calendar: CalendarEntry) => ({
        iconId,
        calendar,
    })
);

/**
 * The action first confirms from user whether they want to delete and if they do
 * then it deleted the calendar.
 */
export const confirmAndDeleteCalendar = action(
    'confirmAndDeleteCalendar',
    (calendar: CalendarEntry, onDelete?: (isDeleted: boolean) => void) => ({
        calendar,
        onDelete,
    })
);

/**
 * The action to open context Menu on calendar picker
 */
export const showCalendarContextMenu = action(
    'showCalendarContextMenu',
    (scenarioId: CalendarPickerScenarioId, calendarId: string, anchorElement: Element) => ({
        scenarioId,
        calendarId,
        anchorElement,
    })
);

/**
 * The action to set which calendars are visible in condensed view per scenario
 */
export const setScenarioCondensedViewCalendars = action(
    'setScenarioCondensedViewCalendars',
    (
        selectedCalendars: CalendarEntry[],
        scenarioId: CalendarPickerScenarioId,
        userIdentity: string
    ) => ({
        selectedCalendars,
        scenarioId,
        userIdentity,
    })
);

export const userSelectedCalendar = action('userSelectedCalendar', (calendar: CalendarEntry) => ({
    calendar,
}));

export const calendarSelected = action('calendarSelected', (calendar: CalendarEntry) =>
    addDatapointConfig({ name: 'selectCalendarOnCalendarPicker' }, { calendar })
);
